import { render, staticRenderFns } from "./KioskLogin.vue?vue&type=template&id=5858deb5&scoped=true"
import script from "./KioskLogin.vue?vue&type=script&lang=js"
export * from "./KioskLogin.vue?vue&type=script&lang=js"
import style0 from "./KioskLogin.vue?vue&type=style&index=0&id=5858deb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5858deb5",
  null
  
)

export default component.exports